// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"664":"62a519ff","802":"96689b15"}[chunkId] + ".chunk.css";
};